import React from 'react'
import { connect } from 'react-redux'
import Loader from 'components/D3Loader'
import { getUserRoleIdByStudy } from 'utils/misc'
import { modalActions } from 'store/modal'
import { actions as notyActions } from 'layouts/ErrorBox'
import { getHeaderName } from '../../../../../utils/visitNameUtils'
import { visitActions } from '../modules/TemplateVisit'
import { actions as visitScheduleActions } from '../../../../VisitSchedulesPage/modules/VisitSchedules'
import VisitPage from '../components/VisitPage'
import { isVersionUatOrLive } from '../../../../../../../../../../../utils/studyConfigUtils'
import {
  getStudyDurationForTimeline,
  getStudyDurationFromStudy,
} from '../../../../../../../../../../../utils/studyDurationForTimeline'

const mapDispatchToProps = { ...visitActions, ...modalActions, ...visitScheduleActions, ...notyActions }

const mapStateToProps = (state, ownProps) => {
  const { studyVersionID } = ownProps?.params || {}
  const { loading, location, sending, study, subroute, user, templateVisitReducer, studyLock, visitSchedules } = state
  const { isDeploy, sendingState, sentState } = sending
  const { templateVisitId, parentScheduleId } = ownProps.params
  const { currentStudy, studyVersionList } = study
  const path = location.pathname.match(/([^/]+$)/)[0]
  const studyID = currentStudy.id
  const isArmsSupported = study?.currentStudy?.config?.visit_support?.arms_enabled

  const hasStudyPromotion = !!study?.currentStudy?.config?.study_promotion
  const isReadOnlyState = hasStudyPromotion && isVersionUatOrLive(studyVersionList, studyVersionID)

  return {
    ...templateVisitReducer,
    isEdit: path === 'edit',
    isLoading: loading.general,
    isSiteCoord: getUserRoleIdByStudy(user, studyID) === 8,
    parentScheduleId,
    path,
    saveSending: !isDeploy && sendingState,
    saveSent: !isDeploy && sentState,
    sendDisabled: sendingState || sentState,
    studyID,
    studyLock,
    subtitleName: getHeaderName(path, subroute, isArmsSupported, isReadOnlyState),
    templateVisitId,
    studyVisitSchedule: visitSchedules.studyVisitSchedule,
    isNewVisitVersion: currentStudy?.config?.visit_support?.version > 1,
    visitCycleCreated: visitSchedules?.visitCycleCreated,
    selectedVisitCycle: visitSchedules?.selectedVisitCycle,
    isArmsSupported,
    isReadOnlyState,
    studyVersionID,
    studyDuration:
      getStudyDurationForTimeline()?.study_duration ?? getStudyDurationFromStudy(currentStudy)?.study_duration,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(props => {
  return props.isLoading ? <Loader active /> : <VisitPage {...props} />
})
